import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username.trim(), password);
      navigate("/ci-panel-7x9k2");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <span className="inline-block w-3 h-3 rounded-sm" style={{ background: "var(--ci-accent)" }} />
          <span className="text-xl font-semibold tracking-tight">CarInspecto</span>
        </div>
        <div className="border border-neutral-200 rounded-lg bg-white p-7">
          <h1 className="text-xl font-semibold tracking-tight mb-1">Вход в админ-панель</h1>
          <p className="text-sm text-neutral-500 mb-6">Введите учётные данные администратора.</p>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="username">Логин</Label>
              <Input
                id="username"
                data-testid="login-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="border-neutral-300"
                autoFocus
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Пароль</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="border-neutral-300"
              />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <Button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="w-full h-11 rounded-lg font-semibold active:scale-[0.98] transition-transform"
              style={{ background: "var(--ci-accent)", color: "#1a1a1a" }}
            >
              {loading ? "Вход…" : "Войти"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
